/**
 * Fire-and-forget POST of the quiz completion to the same-origin
 * `/api/quiz-complete` route, which forwards it to Inngest server-side using
 * the server-only `INNGEST_EVENT_KEY` (the same pattern `/api/waitlist` uses —
 * the event key never reaches the client bundle). Never blocks navigation;
 * reports to Sentry on failure. `keepalive` lets the request survive the
 * navigation to the result view.
 */
import * as Sentry from "@sentry/nextjs"
import type { MarketingQuizCompletedPayload } from "@/lib/quiz/completion-event"

export function sendQuizCompletion(
  payload: MarketingQuizCompletedPayload
): void {
  fetch("/api/quiz-complete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch((err) =>
    Sentry.captureException(err, {
      tags: { event: "marketing_quiz/completed" },
    })
  )
}
